import { path, pathOr } from 'ramda';
import { combineReducers } from 'redux';
import { createSelector } from 'reselect';
import { FETCH_BONUSES_CONTENT_SUCCESS } from '../../../constants/bonuses';
import { UPLOAD_CONTENT_API_PREFIX } from '../../../../constants/content';
import {
  createAllIdsTypeReducer,
  createEntityMapTypeReducer,
} from '../../../helpers/reducerCreator';
import { contentAPIPrefixSelector } from '../../app/configuration';

export const initialState = {
  byId: {},
  allIds: [],
};

export default combineReducers({
  allIds: createAllIdsTypeReducer(
    FETCH_BONUSES_CONTENT_SUCCESS,
    initialState.allIds
  ),
  byId: createEntityMapTypeReducer(
    FETCH_BONUSES_CONTENT_SUCCESS,
    initialState.byId
  ),
});

// SELECTORS
export const getBonusesByIdSelector = (state) =>
  pathOr(initialState.byId, ['domain', 'bonusContent', 'byId'], state);
export const getBonusesAllIdsSelector = (state) =>
  pathOr(initialState.allIds, ['domain', 'bonusContent', 'allIds'], state);

export const getAllBonusDataSelector = createSelector(
  getBonusesByIdSelector,
  (_, id) => id,
  contentAPIPrefixSelector,
  (byId, id, contentAPIPrefix) => {
    const entity = byId[id] || {};
    const imageHash = path(['image', 'hash'], entity);
    const imageExt = path(['image', 'ext'], entity);
    const image = imageHash && imageExt && `${imageHash}${imageExt}`;
    const imageUrl = image
      ? `${contentAPIPrefix}${UPLOAD_CONTENT_API_PREFIX}${image}`
      : null;

    return {
      ...entity,
      imageUrl,
    };
  }
);

export const getBonusItemDataSelector = createSelector(
  getAllBonusDataSelector,
  (bonus) => {
    return {
      imageUrl: pathOr('', ['imageUrl'], bonus),
      title: pathOr('', ['name'], bonus),
      subtitle: pathOr('', ['description_top'], bonus),
      description: pathOr('', ['description'], bonus),
    };
  }
);

export const getBonusPageDataSelector = createSelector(
  getAllBonusDataSelector,
  (bonus) => {
    return {
      imageUrl: path(['imageUrl'], bonus),
      subtitle: pathOr('', ['detail_description_top'], bonus),
      title: pathOr('', ['detail_description_name'], bonus),
      description: pathOr('', ['detail_description'], bonus),
      rules: pathOr('', ['rules'], bonus),
      buttons: pathOr([], ['buttons'], bonus),
    };
  }
);
